var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12034_49743)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.0752,
    height: 51.0752,
    transform: "translate(0.621155)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1291 14.3922H28.4804L29.312 12.7911H41.1291C43.8703 12.7911 46.0925 15.0133 46.0925 17.7545V34.7262C46.0925 37.4674 43.8703 39.6896 41.1291 39.6896H23.3568L24.3175 38.0885H41.1291C42.986 38.0885 44.4914 36.5832 44.4914 34.7262V17.7545C44.4914 15.8975 42.986 14.3922 41.1291 14.3922Z",
    fill: "#D1112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.194 38.0885H5.58458C3.72762 38.0885 2.22226 36.5832 2.22226 34.7262V17.7545C2.22226 15.8975 3.72762 14.3922 5.58458 14.3922H22.0903L23.0606 12.7911H5.58458C2.84335 12.7911 0.621155 15.0133 0.621155 17.7545V34.7262C0.621155 37.4674 2.84336 39.6896 5.58458 39.6896H18.2333L19.194 38.0885Z",
    fill: "#D1112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2133 19.996H47.5335C49.8326 19.996 51.6963 21.8598 51.6963 24.1589V28.0016C51.6963 30.3006 49.8326 32.1644 47.5335 32.1644H47.2133V19.996Z",
    fill: "#D1112B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5508 28.3217L26.8793 11.35L23.677 23.8386H32.8033L20.4748 40.1699L23.9973 28.3217H14.5508Z",
    fill: "#D1112B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12034_49743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.0752,
    height: 51.0752,
    fill: "white",
    transform: "translate(0.621155)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcBattery);
export default __webpack_public_path__ + "static/media/ACBattery.df343c5240a04c64c05310af57521089.svg";
export { ForwardRef as ReactComponent };